import { Component, ViewEncapsulation, Inject, ElementRef } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { TrackingsService } from '../../../services/tracking.service';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
  selector: "checkout-guarantee-warning-aside-panel",
  templateUrl: "./checkout-guarantee-warning-aside-panel.component.html",
  styleUrls: ["checkout-guarantee-warning-aside-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CheckoutGuaranteeWarningSidePanelComponent extends DialogPanelComponentContent {
  private isGuaranteeAccepted: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<CheckoutGuaranteeWarningSidePanelComponent>,
    private tracking: TrackingsService
  ) {
    super(elementRef, true);

    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Scenario': this.data.stock.isDayTrade ? 'Day Trade' : 'Swing Trade',
      'Step': 'Checkout',
      'Time Responsável': 'Roebling',
      'Text': 'Utilização da garantia',
    });
  }

  public acceptGuarantee() {
    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Bolsa',
      'Element': 'Botão concordar e seguir para revisão',
      'Group': 'Modal',
      'Scenario': this.data.stock.isDayTrade ? 'Day Trade' : 'Swing Trade',
      'Step': 'Checkout',
      'Time Responsável': 'Roebling',
    });

    this.isGuaranteeAccepted = true;
    this.close(this.dialogReference, this.isGuaranteeAccepted);
  }

  public redirectExternal(url: string) {
    window.location.href = `${url}`;
  }

  public redirectBack() {
    this.close(this.dialogReference, null);
  }
}
